<div class="content row d-flex align-content-center">
  <div class="col-6 col-md-4 offset-md-4 text-center">
    @if (complete$ | async) {
      <div class="message-container">
        <grid-ui-icon class="small-check" name="tick-circle"></grid-ui-icon>
        Your extract is ready to download.
        <a class="action-text download-link" (click)="downloadExtract()" data-testid="link-download-now">Download now</a>
      </div>
    } @else {
      <div class="message-container">
        <grid-ui-loading class="loading-icon" [message]="''" [color]="'secondary'"> </grid-ui-loading>
        <span
          >Your extract is being generated.
          <a class="action-text" (click)="cancel()" data-testid="link-cancel-extract">Cancel extract</a></span
        >
      </div>
    }
  </div>
  <div class="col-6 col-md-4 text-right pe-5">
    <a class="action-text" (click)="closeNotification()" data-testid="link-dismiss">Dismiss this notice (will not affect download)</a>
  </div>
</div>
